import React from "react";
import { NoticeContainer } from "./styles";
import { DataHeading, DataValue } from "../../commonStyles";

export default function SoftAlert(props) {
  return (
    <div className={props.className}>
      <NoticeContainer
        message={
          <div>
            <DataValue>
              {props.heading} {props.date}
            </DataValue>
            <DataHeading>{props.mainbody}</DataHeading>
          </div>
        }
      />
    </div>
  );
}
